import { Link } from "react-router-dom";
import klarnaLogo from "@/assets/klarna-logo.svg";
import { trackEvent } from "@/lib/analytics";

const PABAU_BASE =
  "https://partner.pabau.com/online-bookings/dr-vahe-clinic?category=183921&services=3588997&fallback=true";

const Booking = () => {
  const bookingUrl = `${PABAU_BASE}&promo=preferred-rates`;

  return (
    <section id="booking" className="py-24 md:py-32 px-6 md:px-10">
      <div className="max-w-6xl mx-auto bg-secondary rounded-[40px] md:rounded-[60px] p-10 md:p-16 lg:p-20 relative overflow-hidden shadow-soft">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 relative z-10 items-center">
          <div className="space-y-8">
            <span className="text-[10px] tracking-[0.35em] uppercase text-accent font-medium">
              Request Your Placement
            </span>
            <h2 className="font-display text-4xl md:text-5xl text-foreground text-balance">
              Begin with a <span className="italic">considered</span> conversation.
            </h2>
            <p className="text-muted-foreground font-light leading-relaxed">
              Reserve your private consultation with Dr Vahe through our secure online booking
              system. Choose your preferred date and our clinical coordinator will confirm
              your placement.
            </p>
            <ul className="space-y-4 text-sm text-foreground/80 font-light pt-4">
              <li className="flex items-center gap-4">
                <span className="size-1.5 rounded-full bg-accent" />
                Available at our London surgical suite
              </li>
              <li className="flex items-center gap-4">
                <span className="size-1.5 rounded-full bg-accent" />
                Preferred promotional rates currently available
              </li>
              <li className="flex items-center gap-4">
                <span className="size-1.5 rounded-full bg-accent" />
                Discreet concierge care throughout
              </li>
              <li className="flex items-center gap-4">
                <span className="size-1.5 rounded-full bg-accent" />
                <span className="flex items-center gap-3">
                  Pay in instalments with
                  <img
                    src={klarnaLogo}
                    alt="Klarna"
                    width={56}
                    height={24}
                    className="h-6 w-auto rounded"
                    loading="lazy"
                  />
                </span>
              </li>
            </ul>
          </div>

          <div className="bg-background rounded-[32px] p-8 md:p-10 flex flex-col space-y-6 shadow-soft">
            <div className="text-center space-y-3">
              <span className="text-[10px] tracking-[0.35em] uppercase text-accent font-medium">
                Secure Online Booking
              </span>
              <h3 className="font-display text-2xl md:text-3xl text-foreground text-balance">
                Reserve your placement
              </h3>
            </div>

            <div className="border border-accent bg-accent/5 rounded-2xl p-5 text-center shadow-soft">
              <p className="font-display text-base text-foreground">Preferred promotional rates</p>
              <p className="text-xs text-muted-foreground font-light mt-1 leading-relaxed">
                Available throughout the year, subject to consultation and appointment availability.
              </p>
            </div>

            <a
              href={bookingUrl}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() =>
                trackEvent("pabau_booking_open", {
                  location: "booking_section",
                  promo: "preferred-rates",
                  label: "Request Availability",
                })
              }
              className="inline-block w-full py-5 bg-primary text-primary-foreground rounded-full text-xs uppercase tracking-[0.3em] text-center hover:bg-accent transition-all duration-500 cursor-pointer shadow-soft"
            >
              Request Availability
            </a>
            <div className="flex items-center justify-center gap-2 pt-1 text-[11px] text-muted-foreground font-light">
              <span>Or pay in instalments with</span>
              <img
                src={klarnaLogo}
                alt="Klarna"
                width={56}
                height={24}
                className="h-6 w-auto rounded"
                loading="lazy"
              />
            </div>
            <p className="text-[10px] tracking-[0.2em] uppercase text-muted-foreground text-center">
              Your details are kept strictly confidential
            </p>
            <p className="text-[11px] text-muted-foreground/80 font-light text-center leading-relaxed">
              By submitting an enquiry you agree to our{" "}
              <Link
                to="/terms"
                className="underline underline-offset-2 hover:text-accent transition-colors"
              >
                Terms of Service
              </Link>{" "}
              and acknowledge our{" "}
              <Link
                to="/privacy"
                className="underline underline-offset-2 hover:text-accent transition-colors"
              >
                Privacy Policy
              </Link>
              . Treatment is subject to consultation and clinical suitability.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Booking;
